class DetailsModal extends HTMLElement {
  constructor() {
    super();
    this.detailsContainer = this.querySelector('details');
    this.summaryToggle = this.querySelector('summary');

    this.detailsContainer.addEventListener('keyup', (event) => event.code.toUpperCase() === 'ESCAPE' && this.close());
    this.summaryToggle.addEventListener('click', this.onSummaryClick.bind(this));
    this.querySelector('button[type="button"]').addEventListener('click', this.close.bind(this));

    this.summaryToggle.setAttribute('role', 'button');

    // Covers state changes that never pass through open()/close(): something else
    // setting the open attribute directly, or a browser flipping it itself, fires
    // `toggle` and nothing else. `toggle` is queued, so open()/close() still write
    // the attribute synchronously and this only has to agree with them.
    this.detailsContainer.addEventListener('toggle', this.syncExpanded.bind(this));
    this.syncExpanded();
  }

  isOpen() {
    return this.detailsContainer.hasAttribute('open');
  }

  /**
   * `aria-haspopup="dialog"` on the trigger described a dialog whose open state could
   * never be reported, and nothing set aria-expanded on either side: the static
   * markup had none and this element never added one. Derived from the open
   * attribute rather than from click handling so it is right after every path that
   * can change the state — summary click, Escape, overlay click, the close button,
   * a caller calling close() directly, and the `toggle` event for a browser that
   * flips `open` on its own.
   */
  syncExpanded() {
    this.summaryToggle.setAttribute('aria-expanded', String(this.isOpen()));
  }

  onSummaryClick(event) {
    event.preventDefault();
    this.isOpen() ? this.close() : this.open(event);
  }

  onBodyClick(event) {
    if (!this.contains(event.target) || event.target.classList.contains('modal-overlay')) this.close(false);
  }

  open(event) {
    this.onBodyClickEvent = this.onBodyClickEvent || this.onBodyClick.bind(this);
    // this.detailsContainer rather than event.target.closest('details'): a caller
    // outside the disclosure can open it — the mobile tab bar's Search slot does
    // exactly that, passing its own click event — and there is no 'details' ancestor
    // to find from that target.
    this.detailsContainer.setAttribute('open', true);
    document.body.addEventListener('click', this.onBodyClickEvent);
    document.body.classList.add('overflow-hidden');
    this.syncExpanded();

    trapFocus(
      this.detailsContainer.querySelector('[tabindex="-1"]'),
      this.detailsContainer.querySelector('input:not([type="hidden"])')
    );
  }

  close(focusToggle = true) {
    removeTrapFocus(focusToggle ? this.summaryToggle : null);
    this.detailsContainer.removeAttribute('open');
    document.body.removeEventListener('click', this.onBodyClickEvent);
    document.body.classList.remove('overflow-hidden');
    this.syncExpanded();
  }
}

customElements.define('details-modal', DetailsModal);
